// Thrown by useApi once the failure has already been shown to the user
export class ReportedRequestError extends Error {
  constructor(method: string, endpoint: string, cause: unknown) {
    super(`${method} ${endpoint} failed`, { cause });
    this.name = "ReportedRequestError";
  }
}
